<div *ngIf="!loadingPage else loadingTemplate">
  <div class="row mb-5">
    <div class="col card">
      <div class="col px-0">
        <h3 class="mb-4">Status do Agendamento</h3>
      </div>

      <div class="row px-0" [formGroup]="formGroup">
        <div class="col-6 px-0 pr-4">
          <app-basic-input id="name" label="Nome" controlName="name" [formGroup]="formGroup"></app-basic-input>
        </div>
        <div class="col-3 px-0 pr-2">
          <label>Cor do plano de fundo</label>
          <div class="input-color">
            <input type="color" formControlName="background_color" id="background_color">
          </div>
        </div>
        <div class="col-3 px-0 pl-2">
          <label>Cor do texto</label>
          <div class="input-color">
            <input type="color" formControlName="font_color" id="font_color">
          </div>
        </div>
        <div class="col-12 selector px-0 mt-4">
          <input class="mr-2" formControlName="can_overschedule" id="can_overschedule" type="checkbox">
          <label class="align-self-center" for="can_overschedule">
            Liberar horário quando selecionado
          </label>
        </div>

        <div class="col-12">
          *Se este campo estiver marcado, os agendamentos com este status não bloqueiam o horário da agenda
        </div>

        <div class="col-12 selector px-0 mt-4">
          <input class="mr-2" formControlName="default" id="default" type="checkbox">
          <label class="align-self-center" for="default">
            Definir como status padrão
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-end mt-5 mb-5">
    <div class="col-12 col-md-3 mb-3">
      <button (click)="cancelHandler()" class="btn btn-link btn-lg" type="button">
        Cancelar
      </button>
    </div>

    <div class="col-12 col-md-3 mb-3" *ngIf="button">
      <button (click)="removeHandler()" [disabled]="submitting" class="btn btn-secondary btn-lg" type="button">
        {{removeButton}}
      </button>
    </div>

    <div class="col-12 col-md-3 mb-3">
      <button (click)="submitHandler()" [disabled]="submitting" class="btn btn-primary btn-lg" type="button">
        {{submitButton}}
        <span class="spinner-border" *ngIf="submitting"></span>
      </button>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="col card full-loading text-center">
    <div class="spinner-border spinner-border-xl" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-template>
